.messages {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--dixa-size-spacer-300) var(--dixa-size-spacer-400);
}
